module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-tested-solutions.en@1x-ea961f9b108a5dc9339740b4c35cc053.png";